module.exports = {"id":"209346","name":"Kirill Panchenko","rating":"74","photo":"./data/images/photos/4/209346.png","club":{"name":"Dynamo Moscou","logo":"./data/images/clubs/DynamoMoscou.png"},"positions":["ATT","MOC","BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KirillPanchenko0.json
// module id = 2389
// module chunks = 0